module.exports = __webpack_public_path__ + "img/9788932027333.49187911.jpg";